import type { Runtime } from './runtime';
import { Account } from '../account/account';
import { createAccountDialog } from '../ui/accountDialog';

export type AccountRuntime = ReturnType<typeof createAccountRuntime>;

/** The visitor's account, from the gateway onward. While its dialog is open in the city the
 *  visitor stands still, as for the book and the chat. */
export function createAccountRuntime() {
  const account = new Account();
  let entered: Runtime | null = null;
  const dialog = createAccountDialog(account, (open) => {
    const rt = entered;
    rt?.input?.setEnabled(
      !open &&
        !rt.menuOpen &&
        !rt.ui.helpOpen &&
        !rt.communications.isOpen &&
        !rt.discoveries.isOpen
    );
  });
  void account.refresh();
  return {
    account,
    /** The city now exists: its visitor is held still while the dialog is open. */
    attach(runtime: Runtime): void {
      entered = runtime;
    },
    open: (): void => {
      dialog.open();
    },
  };
}
